import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AppRoutingService {

  goToOllie(): void {
    window.location.href = environment.ollie;
  }

  goToAssessments(path: string = ''): void {
    window.location.href = environment.assessments + '/' + path;
  }

  gotToAccess(path: string = ''): void {
    window.location.href = environment.access + '/' + path;
  }

  gotToOllie (path: string = ''): void {
    window.location.href = environment.ollie + '/' + path;
  }

  goToAdmin(path: string = ''): void {
    window.location.href = environment.admin + '/' + path;
  }

  getAdminUrl(path: string = ''): string {
    return environment.admin + '/' + path;
  }

  getOllieUrl(path: string = ''): string {
    return environment.ollie + '/' + path;
  }

  getAssessmentsUrl(path: string = ''): string {
    return environment.assessments + '/' + path;
  }

  getAccessUrl(path: string = ''): string {
    return environment.access + '/' + path;
  }

  getApi(): string {
    return environment.api + '/api/'
  }
}